import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authHeaderInterceptor } from './shared/interceptors/auth-header.interceptor';
import { provideAuth } from 'angular-auth-oidc-client';
import { environment } from '../environments/environment';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimations(),
    provideRouter(
      routes,
      withRouterConfig({ paramsInheritanceStrategy: 'always' })
    ),
    provideHttpClient(withInterceptors([authHeaderInterceptor])),
    provideAuth({
      config: {
        authority: environment.cognitoAuthority,
        redirectUrl: environment.redirectUrl,
        clientId: environment.cognitoClientId,
        scope: 'email openid',
        responseType: 'code',
      },
    }),
    provideCharts(withDefaultRegisterables()),
  ],
};
